"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countCachePrimitiveFrames = countCachePrimitiveFrames;
const OrcadDsnCfbStreamUtils_1 = require("./OrcadDsnCfbStreamUtils");
function countCachePrimitiveFrames(bytes, offset, record, records, primitives, diagnostics, extent) {
    let cursor = offset;
    let container = record;
    let count = 0;
    while (cursor < bytes.length) {
        if (cursor === container.offset + container.byteLength) {
            const next = records.get(cursor);
            if (!next) {
                return undefined;
            }
            container = next;
        }
        const end = container.offset + container.byteLength;
        if (cursor + 2 > end) {
            return undefined;
        }
        if (bytes[cursor] === 0 || bytes[cursor] !== bytes[cursor + 1]) {
            if (extent) {
                extent.endOffset = cursor;
            }
            return count;
        }
        if (cursor + 10 > end || container.byteLength === container.payloadByteLength) {
            return undefined;
        }
        const byteLength = OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.readUInt32LE(bytes, cursor + 2) + 10;
        const compound = bytes[cursor] === 0x30 ? symbolVectorEndRecord(bytes, cursor, byteLength, container, records) : undefined;
        if (byteLength <= 10 || (cursor + byteLength > end && !compound)) {
            return undefined;
        }
        if (compound) {
            container = compound;
        }
        const drawing = primitives.get(cursor);
        if (!drawing || drawing.byteLength !== byteLength) {
            const opcode = Array.from(bytes.subarray(cursor, cursor + 3), (value) => value.toString(16).padStart(2, '0')).join('');
            diagnostics.push({
                severity: 'warning',
                code: 'cache-primitive-undecoded',
                message: `CFB cache primitive [cache-primitive-undecoded] viewOffset=${record.offset} offset=${cursor} opcode=${opcode} byteLength=${byteLength}: frame counted; drawing withheld`,
                streamPath: 'Root Entry/Cache',
                offset: cursor,
                details: { byteLength, viewOffset: record.offset },
            });
        }
        count++;
        cursor += byteLength;
    }
    if (extent) {
        extent.endOffset = cursor;
    }
    return count;
}
function symbolVectorEndRecord(bytes, offset, byteLength, header, records) {
    const end = offset + byteLength;
    if (end > bytes.length ||
        offset + 36 > end ||
        header.offset + header.byteLength !== offset + 30 ||
        bytes[offset + 10] !== 0x30 ||
        OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.readUInt32LE(bytes, offset + 11) !== 11 ||
        bytes[offset + 19] !== 0x30 ||
        OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.readUInt16LE(bytes, offset + 20) !== 0xffff) {
        return undefined;
    }
    let record = records.get(offset + 30);
    if (!record) {
        return undefined;
    }
    const count = OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.readUInt16LE(bytes, offset + 34);
    let cursor = offset + 36;
    for (let index = 0; index < count; index++) {
        if (cursor + 11 > end || bytes[cursor + 1] !== 0 || bytes[cursor] !== bytes[cursor + 2]) {
            return undefined;
        }
        const childEnd = cursor + OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.readUInt32LE(bytes, cursor + 3) + 11;
        if (childEnd > end ||
            childEnd !== record.offset + record.byteLength ||
            record.byteLength === record.payloadByteLength) {
            return undefined;
        }
        const next = records.get(childEnd);
        if (!next) {
            return undefined;
        }
        record = next;
        cursor = childEnd;
    }
    if (cursor + 3 > end || end > record.offset + record.payloadByteLength) {
        return undefined;
    }
    const nameLength = OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.readUInt16LE(bytes, cursor);
    return cursor + nameLength + 3 === end && bytes[end - 1] === 0 ? record : undefined;
}
//# sourceMappingURL=OrcadDsnCfbCachePrimitiveFrames.js.map